import Swiper from "swiper";
import {A11y, Keyboard, Navigation, Autoplay} from "swiper/modules";

new Swiper('.sidebar .highlight-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    watchSlidesProgress: true,
    modules: [Keyboard, A11y, Autoplay],
    keyboard: {
        enabled: true,
        pageUpDown: false
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: true
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 36,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 8,
        },
    }
});

new Swiper('.highlight-swiper:not(.swiper-initialized)', {
    slidesPerView: 1,
    spaceBetween: 10,
    watchSlidesProgress: true,
    loop: true,
    modules: [Navigation, Keyboard, A11y, Autoplay],
    keyboard: {
        enabled: true,
        pageUpDown: false
    },
    nextSlideMessage: "Nächster Slide",
    autoplay: {
        delay: 4000,
        disableOnInteraction: true
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 36,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 36,
        },
    }
});